import React from 'react'
import '../styles/Hello.css'

import Header from '../components/Header'
import Navigation from '../components/Navigation'
import FloatingProductsBackground from '../components/FloatingProductsBackground'

const Hello = () => {
  return (
    <section className="Hello">
        <FloatingProductsBackground/>
        <Header />
        <Navigation />
    </section>
  )
}

export default Hello